<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <h1 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Reset Password
        </h1>
        <p class="mt-2 text-center text-sm text-gray-600">
          Enter your username and we'll send you a link to reset your password.
        </p>
      </div>
      <form @submit.prevent="requestReset" class="mt-8 space-y-6">
        <div
          v-if="message"
          :class="[
            'mb-4 p-3 rounded border',
            success
              ? 'bg-green-100 text-green-700 border-green-300'
              : 'bg-red-100 text-red-700 border-red-300',
          ]"
        >
          {{ message }}
        </div>
        <div class="rounded-md shadow-sm">
          <div>
            <input
              type="text"
              v-model="username"
              required
              class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
              placeholder="Username"
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out disabled:opacity-50"
          >
            {{ loading ? "Sending..." : "Send Reset Link" }}
          </button>
        </div>

        <div class="text-sm text-center">
          <router-link
            to="/login"
            class="font-medium text-gray-600 hover:text-gray-900"
          >
            Back to Login
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { requestPasswordReset } from "@/services/authService";

export default {
  name: "PasswordResetRequest",
  data() {
    return {
      username: "",
      message: "",
      success: false,
      loading: false,
    };
  },
  methods: {
    async requestReset() {
      this.loading = true;
      this.message = "";
      try {
        await requestPasswordReset(this.username);
        this.success = true;
        this.message = "Password reset link has been sent to your email.";
        this.username = "";
      } catch (error) {
        this.success = false;
        this.message = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
